class DbPathHelper {
    static getLoginPath() {
        return '/Token/Login';
    }

    static getUserMfaDetailsPath() {
        return '/Token/GetUserMFADetail';
    }

    static getSendOtpPath() {
        return '/Token/SendOtp';
    }

    static getVerifyOtpPath() {
        return '/Token/VerifyOtp';
    }

    static getMfaTrustPath() {
        return '/Token/TrustDevice';
    }

    static getSelectClientPath() {
        return '/Token/SelectClient';
    }

    static getLoginSsoPath() {
        return '/Token/Sso';
    }

    static getLetterTemplateDynamicFields() {
        return '/LetterTemplate/GetDynamicValues';
    }
}

export {DbPathHelper};